export default class AutoSubmit {
  constructor(el) {
    this.el = el;

    el.addEventListener('change', (e) => {
      let form = el.closest('form');

      if (el.form && document.getElementById(el.form)) {
        form = document.getElementById(el.form);
      }

      if (!form) {
        return;
      }

      form.submit();
    }, false);
  }
}
